

/*
                                    */


import React, { memo } from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import * as model from '../../data/model';
import * as types from '../../types'
import { Tooltip } from "@material-ui/core";
import {
    defaultFont,
    primaryColor,
    infoColor,
    successColor,
    warningColor,
    dangerColor
} from "src/assets/jss/material-dashboard-pro-react.jsx";

const styles: any = theme => ({
    successText: {
        color: successColor,
        paddingRight: '5px',
        paddingLeft: '5px'
    },
    subscribeButton: {


    },
    warningText: {
        color: warningColor,
        paddingRight: '5px',
        paddingLeft: '5px'
    },

});

interface PodCastStatusProps {
    podcast: model.PodCast;
    classes: any;
}
interface PodCastStatusState {

}
class SubscribeDialog extends React.Component<PodCastStatusProps, PodCastStatusState> {


    constructor(props: PodCastStatusProps) {
        super(props);

        this.state = {


        };

    }

    render() {
        const { classes } = this.props;
        let podcast = this.props.podcast;
        return (

            <span>

                {podcast.feed_status == model.PodCastFeedStatus.dirty &&
                    <span className={classes.warningText}>
                        <img width={20} height={20} src='/loading.gif' />
                        Updating
</span>
                }
                {podcast.feed_status == model.PodCastFeedStatus.pendingSync &&
                    <span className={classes.warningText}>
                        <img width={20} height={20} src='/loading.gif' />
                        Getting Ready to Sync Rss
</span>
                }
                {podcast.feed_status == model.PodCastFeedStatus.sync &&
                    <span className={classes.warningText}>
                        <img width={20} height={20} src='/loading.gif' />
                        Syncing Rss
</span>
                }
                {podcast.feed_status == model.PodCastFeedStatus.error &&
                    <Tooltip title={podcast.last_error} >
                        <span className={classes.errorText}>

                            Error creating stream.
</span></Tooltip>
                }
                {podcast.feed_status == model.PodCastFeedStatus.ready &&
                    <span className={classes.successText}>
                        Ready to Stream!
</span>
                }
            </span>

        );
    }
}

export function mapStateToProps(state: types.IState) {
    return {
        connect: state
    };
}
export default connect(
    mapStateToProps,
    null
)(withStyles(styles as any)(SubscribeDialog));







// WEBPACK FOOTER //
// ./src/views/podcast/PodCastStatus.tsx